import sharebuzzer from "../assets/sharebuzzer.jpg";
import addbuzzer from "../assets/addbuzzer.jpg";
import realtimequeue from "../assets/realtimequeue.jpg";
import notifications from "../assets/notifications.jpg";
import recenthistory from "../assets/recenthistory.jpg";
import noqueue from "../assets/noqueue.jpg";
import noqueuesm from "../assets/noqueuesm.jpg";
import saloons from "../assets/haircut.png";
import event from "../assets/event.png";
import restaurant from "../assets/restaurant.png";
import healthcare from "../assets/hospital.png";
import logo from "../assets/pager.png";
import citymotors  from "../assets/citymotors.png";
import csaloon  from "../assets/csaloon.png";

import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

const features = [
  {
    id:'EQM',
    name: 'Easy Queue Management',
    description: 'Add customers to the queue and generate a unique URL for each customer which shows their position on the queue.',
    image: addbuzzer
  },
  {
    id:'MSM',
    name: 'Multiple Sharing Methods',
    description: 'Share the unique URL with using QR codes, email, SMS, and WhatsApp. Buzzerr is designed to use the services already available in your device, keeping it cost effective',
    image: sharebuzzer
  },
  {
    id:'RQU',
    name: 'Real-Time Queue Updates',
    description: 'Buzzerr provides real-time updates on the position of each customer on the queue. Customers can view their position on the queue by visiting the unique URL and can see when it\'s their turn to visit the store.',
    image: realtimequeue
  },
  {
    id:'CSN',
    name: 'Customizable Notifications',
    description: 'You can customize the notifications that are sent to your customers when it\'s their turn to visit the store. You can choose to send notifications via email, SMS, or WhatsApp.',
    image: notifications
  },
  {
    id:'RTH',
    name: 'Buzzer History',
    description: 'Buzzerr makes it easy to keep track of which customers have been served and when, thanks to our audit trail feature. With Buzzerr, you can view a log of recently serviced buzzers/pagers.',
    image: recenthistory
  },
  // {
  //   id:'ANI',
  //   name: 'Analytics and Insights',
  //   description: 'Buzzerr provides analytics and insights on the queue management process. You can view the number of customers served, the average wait time, and other metrics to help you optimize the queue management process.',
  //   image: ''
  // }
]

export const Home = () => {

  const [feature, setFeature] = useState({id:'EQM', name:'Easy Queue Management', description: 'Add customers to the queue and generate a unique URL for each customer which shows their position on the queue.', image: sharebuzzer});
  const [currentFeatureIndex, setCurrentFeatureIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentFeatureIndex(prevIndex =>
        prevIndex === features.length - 1 ? 0 : prevIndex + 1
        );
    }, 10000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    setFeature(features[currentFeatureIndex]);
  }, [currentFeatureIndex]);

  const handleClick = (feature:string) => {
    const fdetails = features.find(obj => obj.id === feature);
    if(fdetails){
      setFeature(fdetails);
    }
  };

  function scrollToFeatures() {
    const featuresSection = document.getElementById('features');
    featuresSection?.scrollIntoView({ behavior: 'smooth' });
  }

  return (
  
  <div className="">

    <div className="relative overflow-hidden" id="hero-element">
      <main className="mt-10 sm:mt-18">
        <div className="mx-auto max-w-full">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
              <div>
                <h1 className="mt-4 text-4xl tracking-tight font-extrabold text-grey sm:mt-5 sm:leading-none lg:mt-6 lg:text-5xl xl:text-6xl">
                  Manage Your Queues <br />
                  Effortlessly Online
                </h1>
                <p className="mt-3 text-base text-gray-400 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                  Streamline your operations and keep your customers happy.
                  Say goodbye to physical buzzers and pagers, and hello to our easy-to-use online queue management system. With unique URLs for each pager, customers can stay updated on their queue status without hassle.
                </p>
                <Link to="/login">
                  <button
                    type="button"
                    className="rounded-md bg-blue-500 text-white font-medium px-6 py-3 mt-6 transition duration-500 ease select-none hover:bg-blue-400 focus:outline-none focus:shadow-outline"
                  >
                    Get Started For Free
                  </button>
                </Link>
                <p className="mt-6 text-sm text-green uppercase tracking-wide font-semibold sm:mt-8">
                  Used Across Industries
                </p>
                <div className="grid gap-8 mt-4 grid-cols-4">
                  <div className="col-span-1 flex justify-start sm:justify-center lg:justify-start sm:col-span-1">
                    <img className="h-10 mt-0.5" src={restaurant} alt="Restaurants" />
                  </div>
                  <div className="col-span-1 flex justify-start sm:justify-center lg:justify-start sm:col-span-1">
                    <img className="h-10" src={healthcare} alt="HealthCare" />
                  </div>
                  <div className="col-span-1 flex justify-start sm:justify-center lg:justify-start sm:col-span-1">
                    <img className="h-10" src={event} alt="Events" />
                  </div>
                  <div className="col-span-1 flex justify-start sm:justify-center lg:justify-start sm:col-span-1">
                    <img className="h-10 -mt-0.5" src={saloons} alt="Saloons" />
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-16 mx-5 sm:mt-12 lg:mt-0 lg:col-span-6">
              <img src={addbuzzer} alt="app screenshot" className="ml-auto mb-3 mr-2" />
              <div className="h-9 p-3 bg-gray-chrome sm:max-w-lg sm:w-full sm:mx-auto rounded-t-lg">
                <div className="browser-actions"></div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <div className="py-20 mx-4 lg:mx-8 relative">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 bg-sky-50 text-sky-900 rounded-xl">
        <div className="text-center pt-8 lg:pt-16 pb-16">
          <h2 className="mt-2 text-4xl leading-10 font-extrabold tracking-tight sm:text-5xl">
            Stop asking your customers to Wait in line. <br/>Wait in Style with Buzzerr.
          </h2>
          <p className="my-4 max-w-3xl text-xl lg:mx-auto">
            No more wasted time waiting in line – with Buzzerr, your customers can relax until they receive the notification that you are ready for them. Upgrade your customer experience today with Buzzerr.
          </p>
          <div
            className="flex flex-row items-center justify-center space-x-10 text-sky-900"
          >
            <img src="/_next/static/media/Logos.7dd3568b.svg" alt="" />
          </div>
        </div>
        <div className="relative">
          <img
            alt="demo"
            srcSet={`${noqueue} 2432w, ${noqueuesm} 640w`}
            src={noqueue}
            width="2432"
            height="902"
            decoding="async"
            data-nimg="1"
            loading="lazy"
            style={{color: 'transparent'}}
          />
        </div>
      </div>
      <div className="max-w-full mx-auto my-5 lg:my-10 p-8 lg:p-16 sm:px-6 lg:px-8 bg-gray-100 text-sky-900 rounded-xl" id="features">
        <div className="relative lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
          <div className="flex flex-col">
            <h2 className="text-2xl leading-9 font-extrabold text-gray-900 tracking-tight sm:text-4xl">
              {feature.name}
            </h2>
            <div className="transition-all">
              <p className="mt-20 text-lg text-gray-500">
                {feature.description}
              </p>
            </div>
            <div className="flex flex-row space-x-4 mt-16">
            <svg 
                width="64px" 
                height="64px" 
                viewBox="0 0 48 48"
                stroke="currentColor"
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className={feature.id === "EQM"? "h-8 w-8 transition-all text-gray-500":"h-8 w-8 transition-all text-gray-300 hover:text-blue-400 cursor-pointer" }
                onClick={() => handleClick("EQM")}
              >
                <path d="M8 28H24" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M8 37H24" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M8 19H40" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M8 10H40" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M30 33H40" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M35 28L35 38" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <svg
                width="64px" 
                height="64px"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
                className={feature.id === "MSM"? "h-8 w-8 transition-all text-gray-500":"h-8 w-8 transition-all text-gray-300 hover:text-blue-400 cursor-pointer" }
                onClick={() => handleClick("MSM")}
              >
                <path d="M8.68439 10.6578L15.3124 7.34378M15.3156 16.6578L8.69379 13.3469M21 6C21 7.65685 19.6569 9 18 9C16.3431 9 15 7.65685 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18Z"></path>
              </svg>
              <svg
                width="64px" 
                height="64px"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
                className={feature.id === "RQU"? "h-8 w-8 transition-all text-gray-500":"h-8 w-8 transition-all text-gray-300 hover:text-blue-400 cursor-pointer" }
                onClick={() => handleClick("RQU")}
              >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4 12C4 7.58172 7.58172 4 12 4C12.5523 4 13 3.55228 13 3C13 2.44772 12.5523 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C14.7611 22 17.2625 20.8796 19.0711 19.0711C19.4616 18.6805 19.4616 18.0474 19.0711 17.6569C18.6805 17.2663 18.0474 17.2663 17.6569 17.6569C16.208 19.1057 14.2094 20 12 20C7.58172 20 4 16.4183 4 12ZM13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V12C11 12.2652 11.1054 12.5196 11.2929 12.7071L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L13 11.5858V6ZM21.7483 15.1674C21.535 15.824 20.8298 16.1833 20.1732 15.97C19.5167 15.7566 19.1574 15.0514 19.3707 14.3949C19.584 13.7383 20.2892 13.379 20.9458 13.5923C21.6023 13.8057 21.9617 14.5108 21.7483 15.1674ZM21.0847 11.8267C21.7666 11.7187 22.2318 11.0784 22.1238 10.3966C22.0158 9.71471 21.3755 9.2495 20.6937 9.3575C20.0118 9.46549 19.5466 10.1058 19.6546 10.7877C19.7626 11.4695 20.4029 11.9347 21.0847 11.8267ZM20.2924 5.97522C20.6982 6.53373 20.5744 7.31544 20.0159 7.72122C19.4574 8.127 18.6757 8.00319 18.2699 7.44468C17.8641 6.88617 17.9879 6.10446 18.5464 5.69868C19.1049 5.2929 19.8867 5.41671 20.2924 5.97522ZM17.1997 4.54844C17.5131 3.93333 17.2685 3.18061 16.6534 2.86719C16.0383 2.55378 15.2856 2.79835 14.9722 3.41346C14.6588 4.02858 14.9033 4.78129 15.5185 5.09471C16.1336 5.40812 16.8863 5.16355 17.1997 4.54844Z" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <svg
                width="64px" 
                height="64px"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
                className={feature.id === "CSN"? "h-8 w-8 transition-all text-gray-500":"h-8 w-8 transition-all text-gray-300 hover:text-blue-400 cursor-pointer" }
                onClick={() => handleClick("CSN")}              
              >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29664 4.72727V5.25342C6.60683 6.35644 4.7276 9.97935 4.79579 13.1192L4.79577 14.8631C3.4188 16.6333 3.49982 19.2727 6.93518 19.2727H9.29664C9.29664 19.996 9.57852 20.6897 10.0803 21.2012C10.582 21.7127 11.2625 22 11.9721 22C12.6817 22 13.3622 21.7127 13.8639 21.2012C14.3656 20.6897 14.6475 19.996 14.6475 19.2727H17.0155C20.4443 19.2727 20.494 16.6278 19.1172 14.8576L19.1555 13.1216C19.2248 9.97811 17.3419 6.35194 14.6475 5.25049V4.72727C14.6475 4.00395 14.3656 3.31026 13.8639 2.7988C13.3622 2.28734 12.6817 2 11.9721 2C11.2625 2 10.582 2.28734 10.0803 2.7988C9.57852 3.31026 9.29664 4.00395 9.29664 4.72727ZM12.8639 4.72727C12.8639 4.72727 12.8633 4.76414 12.8622 4.78246C12.5718 4.74603 12.2759 4.72727 11.9757 4.72727C11.673 4.72727 11.3747 4.74634 11.082 4.78335C11.0808 4.76474 11.0803 4.74603 11.0803 4.72727C11.0803 4.48617 11.1742 4.25494 11.3415 4.08445C11.5087 3.91396 11.7356 3.81818 11.9721 3.81818C12.2086 3.81818 12.4354 3.91396 12.6027 4.08445C12.7699 4.25494 12.8639 4.48617 12.8639 4.72727ZM11.0803 19.2727C11.0803 19.5138 11.1742 19.7451 11.3415 19.9156C11.5087 20.086 11.7356 20.1818 11.9721 20.1818C12.2086 20.1818 12.4354 20.086 12.6027 19.9156C12.7699 19.7451 12.8639 19.5138 12.8639 19.2727H11.0803ZM17.0155 17.4545C17.7774 17.4545 18.1884 16.5435 17.6926 15.9538C17.4516 15.6673 17.3233 15.3028 17.3316 14.9286L17.3723 13.0808C17.4404 9.99416 15.0044 6.54545 11.9757 6.54545C8.94765 6.54545 6.51196 9.99301 6.57898 13.0789L6.61916 14.9289C6.62729 15.303 6.49893 15.6674 6.25806 15.9538C5.76221 16.5435 6.17325 17.4545 6.93518 17.4545H17.0155ZM16.9799 3.20202C17.2945 2.74813 17.9176 2.63524 18.3715 2.94988C19.5192 3.74546 20.8956 5.65348 21.6471 7.9126C21.8214 8.43664 21.5379 9.00279 21.0139 9.17712C20.4898 9.35145 19.9237 9.06795 19.7493 8.5439C19.0892 6.55949 17.9221 5.07189 17.2321 4.59358C16.7782 4.27894 16.6653 3.65592 16.9799 3.20202ZM5.4303 2.94988C5.8842 2.63524 6.50722 2.74813 6.82185 3.20202C7.13649 3.65592 7.0236 4.27894 6.56971 4.59358C5.87969 5.07189 4.71256 6.55949 4.05242 8.5439C3.87809 9.06795 3.31194 9.35145 2.78789 9.17712C2.26384 9.00279 1.98034 8.43664 2.15467 7.9126C2.90619 5.65348 4.2826 3.74546 5.4303 2.94988Z" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <svg 
                width="64px" 
                height="64px" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
                className={feature.id === "RTH"? "h-8 w-8 transition-all text-gray-500":"h-8 w-8 transition-all text-gray-300 hover:text-blue-400 cursor-pointer" }
                onClick={() => handleClick("RTH")}  
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.01112 11.5747L6.29288 10.2929C6.68341 9.90236 7.31657 9.90236 7.7071 10.2929C8.09762 10.6834 8.09762 11.3166 7.7071 11.7071L4.7071 14.7071C4.51956 14.8946 4.26521 15 3.99999 15C3.73477 15 3.48042 14.8946 3.29288 14.7071L0.292884 11.7071C-0.0976406 11.3166 -0.0976406 10.6834 0.292884 10.2929C0.683408 9.90236 1.31657 9.90236 1.7071 10.2929L3.0081 11.5939C3.22117 6.25933 7.61317 2 13 2C18.5229 2 23 6.47715 23 12C23 17.5228 18.5229 22 13 22C9.85817 22 7.05429 20.5499 5.22263 18.2864C4.87522 17.8571 4.94163 17.2274 5.37096 16.88C5.80028 16.5326 6.42996 16.599 6.77737 17.0283C8.24562 18.8427 10.4873 20 13 20C17.4183 20 21 16.4183 21 12C21 7.58172 17.4183 4 13 4C8.72441 4 5.23221 7.35412 5.01112 11.5747ZM13 5C13.5523 5 14 5.44772 14 6V11.5858L16.7071 14.2929C17.0976 14.6834 17.0976 15.3166 16.7071 15.7071C16.3166 16.0976 15.6834 16.0976 15.2929 15.7071L12.2929 12.7071C12.1054 12.5196 12 12.2652 12 12V6C12 5.44772 12.4477 5 13 5Z" stroke-linecap="round" stroke-linejoin="round">
                </path>
              </svg>
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
                className={feature.id === "ANI"? "h-8 w-8 transition-all text-gray-500":"h-8 w-8 transition-all text-gray-300 hover:text-blue-400 cursor-pointer" }
                onClick={() => handleClick("ANI")}                  
              >
                <path d="M3 3V21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M21 21H3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M7 16L12.25 10.75L15.75 14.25L21 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg> */}
            </div>
          </div>
          <div className="mt-10 -mx-4 relative lg:mt-0" aria-hidden="true">
            <img
              alt="feature preview"
              srcSet={feature.image}
              src={feature.image}
              decoding="async"
              data-nimg="1"
              className="relative mx-auto rounded-xl"
              loading="lazy"
              style={{color: 'transparent'}}
            />
          </div>
        </div>
      </div>
      <div
        className="max-w-full mx-auto grid grid-cols-1 lg:grid-cols-12 space-y-5 lg:space-y-0 lg:space-x-10"
      >
        <div className="col-span-7 bg-orange-50 text-orange-900 rounded-xl">
          <div className="p-8">
            <h2
              className="text-2xl leading-9 font-extrabold tracking-tight sm:text-3xl"
            >
              Simplicity is a feature.
            </h2>
            <p className="my-4">
              Buzzerr is easy to use for everybody. We've designed Buzzerr to be easy to set up, so you can start using it right away without any complicated installation or configuration processes. With its simple design and intuitive features, Buzzerr requires minimal training for your staff to start using it effectively.
            </p>
          </div>
        </div>
        <div className="col-span-5 bg-emerald-50 text-emerald-900 rounded-xl">
          <div className="p-8">
            <h2
              className="text-2xl leading-9 font-extrabold tracking-tight sm:text-3xl"
            >
              Integration with device apps.
            </h2>
            <p className="my-4">
              With Buzzerr, you can integrate your existing apps to handle sending messages bringing down the cost of queue management, making it an affordable solution for businesses of all sizes.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white" id="extensions">
        <div className="max-w-7xl mx-auto pt-20 pb-8 px-2 sm:pb-5 sm:px-3 lg:px-4">
          <div className="text-center">
            <h2 className="text-base font-semibold text-blue-600 tracking-wide uppercase">
              WaitList
            </h2>
            <p
              className="mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight"
            >
              Display your live waitlist on a big screen or embed it on your site.
            </p>
            <p className="max-w-2xl mt-5 mx-auto text-xl text-gray-500">
              The waitlist updates itself automatically as users are added or removed, making it perfect for display on a big screen or embedding on your site.
            </p>
          </div>
          <div className="grid grid-cols-1 gap-4 m-auto max-w-lg md:grid-cols-2 lg:max-w-4xl justify-center mt-10">
            <img
              src={citymotors}
              alt="live waitlist City Motors"
              loading="lazy"
              className="hover:scale-105" />
            <img
              src={csaloon}
              alt="live waitlist Central Saloon"
              loading="lazy"
              className="hover:scale-105"/>
          </div>
        </div>
      </div>

    </div>

    <div className="bg-white text-center text-slate-400 dark:bg-white dark:text-neutral-900 lg:text-left">
      <div
        className="flex items-center justify-center border-b-2 border-neutral-200 p-6 dark:border-neutral-500 lg:justify-between">
        <div className="mr-12 hidden lg:block">
          <span>Get connected with us on social networks:</span>
        </div>
        <div className="flex justify-center">
          <a href="#!" className="mr-6 text-neutral-600 dark:text-neutral-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="currentColor"
              viewBox="0 0 24 24">
              <path
                d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
            </svg>
          </a>
          <a href="#!" className="mr-6 text-neutral-600 dark:text-neutral-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="currentColor"
              viewBox="0 0 24 24">
              <path
                d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
            </svg>
          </a>
          <a href="#!" className="mr-6 text-neutral-600 dark:text-neutral-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="currentColor"
              viewBox="0 0 24 24">
              <path
                d="M7 11v2.4h3.97c-.16 1.029-1.2 3.02-3.97 3.02-2.39 0-4.34-1.979-4.34-4.42 0-2.44 1.95-4.42 4.34-4.42 1.36 0 2.27.58 2.79 1.08l1.9-1.83c-1.22-1.14-2.8-1.83-4.69-1.83-3.87 0-7 3.13-7 7s3.13 7 7 7c4.04 0 6.721-2.84 6.721-6.84 0-.46-.051-.81-.111-1.16h-6.61zm0 0 17 2h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z"
                fill-rule="evenodd"
                clip-rule="evenodd" />
            </svg>
          </a>
          <a href="#!" className="mr-6 text-neutral-600 dark:text-neutral-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="currentColor"
              viewBox="0 0 24 24">
              <path
                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
          </a>
          <a href="#!" className="mr-6 text-neutral-600 dark:text-neutral-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="currentColor"
              viewBox="0 0 24 24">
              <path
                d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
            </svg>
          </a>
          <a href="#!" className="text-neutral-600 dark:text-neutral-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="currentColor"
              viewBox="0 0 24 24">
              <path
                d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
            </svg>
          </a>
        </div>
      </div>
      <div className="mx-6 py-10 text-center md:text-left">
        <div className="grid-1 grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="">
            <h6
              className="mb-4 text-xl	flex items-center justify-center font-semibold md:justify-start">
              <img src={logo} alt="buzzerrlogo" className="mr-3 h-10"/>
              Buzzerr
            </h6>
          </div>
          <div className="">
            <h6
              className="mb-4 flex justify-center font-semibold md:justify-start">
              Product
            </h6>
            <p className="mb-4">
              <a href="/pricing" className="text-neutral-600 dark:text-neutral-400"
                >Pricing</a
              >
            </p>
            <p className="mb-4">
              <a href="#!" onClick={scrollToFeatures} className="text-neutral-600 dark:text-neutral-400"
                >Features</a
              >
            </p>
            <p>
              <a href="https://blog.buzzerr.xyz" className="text-neutral-600 dark:text-neutral-400"
                >Blog</a
              >
            </p>
          </div>
          <div className="">
            <h6
              className="mb-4 flex justify-center font-semibold md:justify-start">
              Useful links
            </h6>
            <p className="mb-4">
              <a href="/terms" className="text-neutral-600 dark:text-neutral-400">
                Terms of Service                
              </a>
            </p>
            <p className="mb-4">
              <a href="/privacy" className="text-neutral-600 dark:text-neutral-400"
                >Privacy Policy</a
              >
            </p>
          </div>
          <div className="flex flex-col items-center justify-center md:justify-start">
            <Link to="/contact">
              <button className="bg-green-500 hover:bg-gren-700 text-white font-bold py-2 px-4 rounded-full">
                Contact Us
              </button>
            </Link>
            <div className="mt-10">
              <a href="https://www.producthunt.com/posts/buzzerr?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-buzzerr" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=387071&theme=light" alt="Buzzerr - Make&#0032;queue&#0032;management&#0032;effortless | Product Hunt" style={{width: '250px', height: '54px'}} width="250" height="54" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  );
}